import axios from 'axios'
import {FC, ReactNode, useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'
import {
  API_URL,
  GetBrowserData,
  URL,
  WebSite,
  brandName,
  fixNumbers,
  hasMegaPayBusinessCapabilities,
  isMegaPay,
  isNotEmpty,
  isValidNationalCode,
  projectName,
  toAbsoluteUrl,
} from '../../../../_metronic/helpers'
import {ListLoading} from '../../../../_metronic/helpers/components/ListLoading'
import {SUPPORT_PHONE, SUPPORT_PHONE_LABEL} from '../../../../_metronic/helpers/supportContact'
import {AuthModel, useAuth} from '../../auth'
import {CustomInputs} from '../../../../_metronic/helpers/components/CustomInputs'
import {
  IInqueryEconomicCode,
  InqueryEconomicCode,
} from '../../auth/components/registeration/InqueryEconomicCode'
import {Button} from 'react-bootstrap'
import {Login} from './Login'
import {TAX_FOLDER_SSO_LOGIN_URL} from '../../auth/core/taxFolderSso'
import {FISCAL_ID_GUIDE_URL} from '../../auth/core/ssoBusinessRegistration'
import {getRegisterFormSaveError} from './registerFormErrors'
import {staffCan} from '../../auth/core/staffAccess'

interface IRegisterFormData {
  currentUser?: AuthModel
  formData?: {
    firstName?: string
    name?: string
    nationalCode?: string
    eCode?: string
    cityName?: string
    stateName?: string
    type?: number
    tradeName?: string
    description?: string
  }
  id: number
  message?: string
  step: number
}

const RegisterForm: FC = () => {
  const {from} = useParams()
  const [first, setFirst] = useState(true)
  const [loading, setLoading] = useState(true)
  const {currentUser} = useAuth()
  const [step, setStep] = useState(0)
  const [id, setId] = useState(0)

  const successLogin = () => {
    getStart()
  }
  const [inqueryLoading, setInqueryLoading] = useState(false)
  const [inquerydata, setInqueryData] = useState<IInqueryEconomicCode>()

  const [mobile, setMobile] = useState('')
  const [type, setType] = useState('1')
  const [tradeName, setTradeName] = useState('')
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [nationalCode, setNationalCode] = useState('')
  const [cityName, setCityName] = useState('')
  const [stateName, setStateName] = useState('')
  const [ECode, setECode] = useState('')
  const [nationalCodeError, setNationalCodeError] = useState('')
  const [message, setMessage] = useState('')
  const [quickRegister, setQuickRegister] = useState(false)
  const [saveError, setSaveError] = useState('')
  // Self-registration goes through the tax-folder SSO, which only knows the ASA panel; the
  // portal always returns to my.asatsp.ir, where the new session then continues.
  const canRegisterWithTaxFolder = hasMegaPayBusinessCapabilities()

  useEffect(() => {
    let error = ''
    if (isNotEmpty(nationalCode) && nationalCode.length == 10) {
      if (!isValidNationalCode(nationalCode)) {
        error = 'کد ملی صحیح نیست.'
      }
    } else if (nationalCode.length > 10) {
      setNationalCode(nationalCode.substring(0, 10))
    }

    setNationalCodeError(error)
  }, [nationalCode])

  useEffect(() => {
    if (first) {
      getStart()
      setFirst(false)
    }
  }, [])

  useEffect(() => {
    if (isNotEmpty(mobile)) {
      getStart()
    }
  }, [mobile])

  const getStart = async () => {
    GetBrowserData().then((data) => {
      axios
        .post(`${API_URL}/registerForm/open`, {
          code: from,
          data: data,
          mobile: mobile,
          id: id,
        })
        .then((response) => {
          const ret = response.data as IRegisterFormData
          setId(ret.id)
          setStep(ret.step)
          setName(ret.formData?.name || '')
          setTradeName(ret.formData?.tradeName || '')
          setDescription(ret.formData?.description || '')
          setNationalCode(ret.formData?.nationalCode || '')
          setECode(ret.formData?.eCode || '')
          setCityName(ret.formData?.cityName || '')
          setStateName(ret.formData?.stateName || '')
          setMessage(ret.message || '')
          setType((ret.formData?.type || 1).toString())
        })
        .finally(() => {
          setLoading(false)
        })
    })
  }

  const nextStep = async () => {
    if (loading) {
      return
    }
    setLoading(true)
    setSaveError('')
    await axios
      .post(`${API_URL}/registerForm/save`, {
        id,
        code: from,
        type,
        name,
        nationalCode: fixNumbers(nationalCode),
        eCode: fixNumbers(ECode),
        stateName,
        cityName,
        tradeName,
        description,
        isFinal: step == 3,
      })
      .then(() => {
        setStep(step + 1)
      })
      .catch((error) => {
        setSaveError(getRegisterFormSaveError(error))
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const prvStep = () => {
    if (step > 1) {
      setSaveError('')
      setStep(step - 1)
    }
  }

  const enter = (e: KeyboardEvent) => {
    const key = e.charCode || e.keyCode || 0

    if (key === 13) {
      e.preventDefault()
      nextStep()
    }
  }

  // The number is the request's id; the CRM lead created from the form carries it too.
  const trackingNumber = (
    <>
      <h3 className='text-primary mt-10'>شماره پیگیری درخواست: {id}</h3>
      <p className='text-gray-700 fs-5 mt-3'>
        اگر خودتان با پشتیبانی تماس گرفتید (
        <a href={`tel:${SUPPORT_PHONE}`} dir='ltr' className='fw-bold'>
          {SUPPORT_PHONE_LABEL}
        </a>
        )، این شماره را اعلام کنید تا کارشناس درخواست شما را سریع‌تر پیدا کند.
      </p>
    </>
  )

  const navigationButtons = (
    <>
      <div className='d-flex align-items-center w-100'>
        <div className='flex-grow-1 text-start'>
          {step > 1 && (
            <button className='btn btn-light' onClick={prvStep}>
              <i className='las la-angle-right fs-2x me-3'></i>
            </button>
          )}
        </div>
        <div className='flex-grow-1 text-end'>
          <button className='btn btn-primary' onClick={nextStep} disabled={loading}>
            {step == 3 ? 'ثبت درخواست' : 'مرحله بعد'}
            <i className='las la-angle-left fs-2x ms-3'></i>
          </button>
        </div>
      </div>
    </>
  )

  return (
    <>
      <div className='row'>
        <div className='col-12 mt-5 text-center'>
          <h2 className='asa-page-heading'>
            {quickRegister ? (
              <>
                ثبت‌نام برای دریافت راهنمایی و{' '}
                <span className='asa-text-gradient'>مشاوره رایگان</span>
              </>
            ) : (
              <>
                ثبت‌نام در {projectName.trim()}،{' '}
                <span className='asa-text-gradient'>آسان‌تر از همیشه!</span>
              </>
            )}
          </h2>
        </div>
        <div className='col-12 mt-10'>
          {loading && <ListLoading />}
          {!currentUser && <Login successFn={successLogin} setMobile={setMobile} />}
          {(!currentUser || !quickRegister) && (
            <>
              <h4 className='text-gray-900 mt-10' style={{textAlign: 'justify'}}>
                {canRegisterWithTaxFolder
                  ? `دو راه برای ثبت‌نام در ${projectName} پیش روی شماست:`
                  : `برای ثبت‌نام در ${projectName}:`}
              </h4>
              <div className='ps-5'>
                {canRegisterWithTaxFolder && (
                  <p className='text-gray-800 fs-5 mt-5' style={{textAlign: 'justify'}}>
                    <span className='text-dark fw-bolder me-2'>
                      ۱) ثبت‌نام سریع با کارپوشه مالیاتی:
                    </span>
                    <br />
                    دکمه «ثبت‌نام با کارپوشه مالیاتی» را بزنید و در درگاه سازمان امور مالیاتی با
                    اطلاعات هویتی کسب‌وکار خود (شناسه ملی یا کد اقتصادی) وارد شوید. پس از بازگشت به{' '}
                    {brandName}، شناسه یکتای حافظه مالیاتی (با کلید {brandName}) را وارد کنید تا
                    کسب‌وکار شما ثبت شود.
                    <br />
                    هنوز شناسه یکتا ندارید؟{' '}
                    <a href={FISCAL_ID_GUIDE_URL} target='_blank' rel='noreferrer'>
                      راهنمای تصویری دریافت شناسه یکتا
                    </a>{' '}
                    را ببینید. در صورت نیاز به راهنمایی، با پشتیبانی {brandName} به شماره{' '}
                    <a href={`tel:${SUPPORT_PHONE}`} dir='ltr' className='fw-bold'>
                      {SUPPORT_PHONE_LABEL}
                    </a>{' '}
                    تماس بگیرید.
                  </p>
                )}
                <p className='text-gray-800 fs-5 mt-3' style={{textAlign: 'justify'}}>
                  <span className='text-dark fw-bolder me-2'>
                    {canRegisterWithTaxFolder && '۲) '}ثبت‌نام با کمک کارشناسان:
                  </span>
                  <br />
                  با شماره موبایل خود وارد شوید، دکمه «مشاوره رایگان» را بزنید و فرم کوتاه آن را
                  تکمیل کنید. این فرم شامل چند سوال ساده است که اطلاعات اولیه شما و کسب‌وکارتان را
                  می‌پرسد.
                  <br />
                  پس از تکمیل فرم، کارشناسان ما در اولین فرصت با شما تماس خواهند گرفت و در انجام
                  مراحل ثبت‌نام و استفاده از سامانه {projectName} و سامانه مؤدیان به شما کمک خواهند
                  کرد.
                </p>
              </div>
              <p>انتخاب روش ثبت‌نام به عهده شماست.</p>
              <p>
                ما در {projectName} تمام تلاش خود را به کار می‌گیریم تا تجربه ثبت‌نامی آسان و بدون
                دردسر را برای شما فراهم کنیم.
              </p>
            </>
          )}
          {!quickRegister && (canRegisterWithTaxFolder || currentUser) && (
            <div className='d-flex flex-wrap justify-content-center gap-3 mt-10'>
              {canRegisterWithTaxFolder && (
                <a href={TAX_FOLDER_SSO_LOGIN_URL} className='btn btn-primary'>
                  <i className='las la-landmark fs-2 me-1' aria-hidden='true'></i>
                  ثبت‌نام با کارپوشه مالیاتی
                </a>
              )}
              {staffCan(currentUser, 'businesses', 'manage') && (
                <a href='/taxpayer/register' className='btn btn-light-primary'>
                  ثبت کسب‌وکار
                </a>
              )}
              {currentUser && (
                <Button
                  className='btn btn-success'
                  onClick={() => {
                    setSaveError('')
                    setQuickRegister(true)
                    // A request that was already sent opens on its status and tracking number
                    // rather than on an empty form that would send it again.
                    setStep((current) => (current >= 4 ? current : 1))
                  }}
                >
                  مشاوره رایگان
                </Button>
              )}
            </div>
          )}
          {currentUser && (
            <>
              {quickRegister && (
                <>
                  {step == 1 && (
                    <>
                      <div className='row'>
                        <div className='col-12'>
                          <CustomInputs
                            type='radio'
                            isRequired
                            stateValue={{
                              value: type,
                              setValue: setType,
                            }}
                            hint={
                              <span className='text-primary'>
                                انتخاب درست نوع کسب و کار، در ایجاد ارتباط صحیح با سامانه مؤدیان و
                                ارائه خدمات متناسب با نیاز شما، بسیار مهم است.
                              </span>
                            }
                            isVertical
                            label={'نوع کسب و کار خود را انتخاب کنید.'}
                            items={[
                              {
                                label: 'حقیقی (اشخاص)',
                                value: 1,
                              },
                              {
                                label: 'مشارکتی (مشارکت مدنی)',
                                value: 2,
                              },
                              {
                                label: 'حقوقی دولتی',
                                value: 3,
                              },
                              {
                                label: 'حقوقی غیر دولتی (خصوصی)',
                                value: 4,
                              },
                              {
                                label: 'اتباع غیر ایرانی',
                                value: 5,
                              },
                            ]}
                          />
                        </div>
                      </div>
                    </>
                  )}
                  {step == 2 && (
                    <div className='row'>
                      <div className='col-12 mt-5 mb-5 fs-3 text-primary'>
                        با توجه به نوع کسب و کار خود، اطلاعات تکمیلی زیر را وارد کنید:
                      </div>
                      {type == '1' && (
                        <>
                          <div className='col-lg-6 mt-5'>
                            <CustomInputs
                              type='text'
                              isRequired
                              stateValue={{
                                value: name,
                                setValue: setName,
                              }}
                              label={'نام و نام خانوادگی'}
                            />
                          </div>
                          <div className='col-lg-6 mt-5'>
                            <CustomInputs
                              type='text'
                              isRequired
                              onKeyDownFn={enter}
                              stateValue={{
                                value: nationalCode,
                                setValue: setNationalCode,
                              }}
                              label={'کدملی'}
                              error={nationalCodeError}
                            />
                          </div>
                        </>
                      )}
                      <div className='col-12 mt-5'>
                        <InqueryEconomicCode
                          //title={type == '1' || type == '2' ? 'شماره اقتصادی' : 'شناسه ملی'}
                          inquerydata={{
                            inquerydata: inquerydata,
                            setInqueryData: setInqueryData,
                          }}
                          loading={{
                            loading: inqueryLoading,
                            setLoading: setInqueryLoading,
                          }}
                          economicCode={{
                            economicCode: ECode,
                            setEconomicCode: setECode,
                          }}
                          nationalCode={{
                            nationalCode: nationalCode,
                            setNationalCode: setNationalCode,
                          }}
                        />
                      </div>
                      {(type == '1' || type == '5') && (
                        <>
                          <div className='col-lg-6 mt-5'>
                            <CustomInputs
                              type='text'
                              isRequired
                              stateValue={{
                                value: stateName,
                                setValue: setStateName,
                              }}
                              label={'نام استان'}
                            />
                          </div>
                          <div className='col-lg-6 mt-5'>
                            <CustomInputs
                              type='text'
                              isRequired
                              stateValue={{
                                value: cityName,
                                setValue: setCityName,
                              }}
                              label={'نام شهر'}
                            />
                          </div>
                        </>
                      )}
                      <div className='col-12 mt-10 fs-4'>
                        <p className='text-info'>
                          اگر از اطلاعاتی که وارد می‌کنید، مطمئن نیستید، نگران نباشید! ما اینجا
                          هستیم تا به شما کمک کنیم.
                        </p>
                        <p className='text-primary'>
                          برای دریافت راهنمایی، می‌توانید از روش‌های زیر استفاده کنید:
                        </p>
                        <ul className='text-primary'>
                          <li>
                            با بخش پشتیبانی تماس بگیرید.{' '}
                            <a
                              className='ms-2 fw-bolder'
                              style={{
                                textAlign: 'right',
                                direction: 'ltr',
                                display: 'inline-block',
                              }}
                              href={`tel:${SUPPORT_PHONE}`}
                            >
                              {SUPPORT_PHONE_LABEL}
                            </a>
                          </li>
                          {/* <li>با بخش پشتیبانی چت کنید. [اینجا]</li> */}
                        </ul>
                        <p className='text-success'>
                          اگر این قسمت را پر نکنید، کارشناسان ما در اسرع وقت با شما تماس خواهند گرفت
                          و شما را راهنمایی خواهند کرد.
                        </p>
                      </div>
                    </div>
                  )}
                  {step == 3 && (
                    <div className='row'>
                      {(type == '1' || type == '2') && (
                        <div className='col-lg-12 mt-5'>
                          <CustomInputs
                            type='text'
                            stateValue={{
                              value: tradeName,
                              setValue: setTradeName,
                            }}
                            label={
                              'برای اینکه کارشناس مربوطه سریع‌تر با شما تماس بگیرد، نام کسب و کار یا نوع کار یا صنف را وارد کنید:'
                            }
                            hint={
                              <>
                                <p className='mt-5 text-info'>
                                  با وارد کردن اطلاعات فوق، به ما کمک می‌کنید تا شما را به کارشناس
                                  مناسب متصل کنیم.
                                </p>
                                <p className='mt-5 text-primary'>
                                  اگر تمایلی به وارد کردن اطلاعات فوق ندارید، می‌توانید بعد از تماس
                                  کارشناس، اطلاعات را به ایشان ارائه دهید.
                                </p>
                              </>
                            }
                          />
                        </div>
                      )}
                      {type != '1' && (
                        <>
                          <div className='col-12 mt-5'>
                            <CustomInputs
                              type='text'
                              stateValue={{
                                value: name,
                                setValue: setName,
                              }}
                              hint={
                                <span className='text-primary mt-5'>
                                  کارشناسان هنگام تماس، شما را با این نام خطاب می‌کنند.
                                </span>
                              }
                              label={'نام و نام خانوادگی شما'}
                            />
                          </div>
                        </>
                      )}
                      <div className='col-12 mt-5'>
                        <CustomInputs
                          type='textarea'
                          stateValue={{
                            value: description,
                            setValue: setDescription,
                          }}
                          label={'توضیحات بیشتر'}
                        />
                      </div>
                    </div>
                  )}
                  {step < 4 && (
                    <>
                      {saveError && (
                        <div
                          className='alert alert-danger d-flex align-items-center mt-8 mb-0'
                          role='alert'
                        >
                          <i
                            className='las la-exclamation-circle fs-2x text-danger me-3'
                            aria-hidden='true'
                          ></i>
                          <span>{saveError}</span>
                        </div>
                      )}
                      <div className='d-none d-lg-block mt-10'>{navigationButtons}</div>
                      <div className='d-lg-none'>
                        <nav className='navbar fixed-bottom navbar-light bg-light text-center shadow'>
                          <div className='container-fluid'>
                            <div className='btn-toolbar w-100'>
                              <div className='btn-group d-flex justify-content-between w-100'>
                                {navigationButtons}
                              </div>
                            </div>
                          </div>
                        </nav>
                      </div>
                    </>
                  )}
                  {step == 4 && (
                    <>
                      <div className='col-12 text-center mt-10'>
                        <h2 className='text-success mt-10'>
                          با تشکر از شما برای انتخاب {brandName}!
                          <br />
                          <br />
                          درخواست مشاوره شما ثبت شد و کارشناسان پشتیبانی به زودی با شما تماس
                          می‌گیرند.
                        </h2>
                        {trackingNumber}
                        <h4 className='text-info mt-10'>ما مشتاقانه منتظر همکاری با شما هستیم!</h4>
                      </div>
                    </>
                  )}
                  {step == 5 && (
                    <>
                      <div className='col-12 text-center mt-10'>
                        <h2 className='text-success'>{message}</h2>
                        {trackingNumber}
                      </div>
                    </>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </div>
    </>
  )
}

export {RegisterForm}
